<template>
	<v-main>
		<v-container fluid fill-height>
			<v-layout justify-center align-center>
				<v-card width="100%" outlined elevation-0>
					<v-toolbar flat class="border_bottom" shaped>
						<!-- solo se aperto da un'altra pagina (es. consigli della scheda prodotto) -->
						<v-btn v-if="ret" icon class="mr-1" :title="ret.label" @click="back"><v-icon>mdi-arrow-left</v-icon></v-btn>
						<v-toolbar-title>Report scorte</v-toolbar-title>
						<v-spacer></v-spacer>
						<span v-if="refreshLabel" class="text-caption grey--text text--darken-1 mr-2 align-self-center">{{ refreshLabel }}</span>
						<v-toolbar-items>
							<v-btn text :loading="refreshing" :disabled="refreshing" title="Ricalcola giacenze, vendite e proposte con i dati di oggi" @click="aggiorna">
								<v-icon>mdi-refresh</v-icon>
							</v-btn>
							<v-menu offset-y left>
								<template v-slot:activator="{ on, attrs }">
									<v-btn text v-bind="attrs" title="Altre azioni" v-on="on"><v-icon>mdi-dots-vertical</v-icon></v-btn>
								</template>
								<v-list dense>
									<v-list-item link @click="esporta({ view: tabValue === 'overview' ? 'reorder' : tabValue })">
										<v-list-item-icon><v-icon small>mdi-arrow-collapse-down</v-icon></v-list-item-icon>
										<v-list-item-title>Esporta {{ tabValue === 'overview' || tabValue === 'reorder' ? 'il riordino (un foglio per fornitore)' : 'questa vista' }}</v-list-item-title>
									</v-list-item>
									<v-list-item link to="/finance/inventory/settings">
										<v-list-item-icon><v-icon small>mdi-tune-variant</v-icon></v-list-item-icon>
										<v-list-item-title>Giorni di consegna e copertura</v-list-item-title>
									</v-list-item>
								</v-list>
							</v-menu>
						</v-toolbar-items>
					</v-toolbar>
					<v-progress-linear v-if="refreshing" :value="refreshProgress" :indeterminate="!refreshProgress" color="primary" height="3" />

					<v-col cols="12">
						<div v-if="report && report.builtAt" class="iv-muted">Calcolato il {{ report.builtAt | moment('DD/MM/YYYY HH:mm') }} · si aggiorna ogni notte e con il pulsante in alto</div>

						<v-tabs v-model="tab" class="mt-1 mb-3" background-color="transparent">
							<v-tab v-for="t in TABS" :key="t.value">{{ t.label }}</v-tab>
						</v-tabs>

						<div v-if="!report && loading" class="iv-empty">
							<v-progress-circular indeterminate color="primary" />
							<div class="iv-muted mt-3">Prima apertura: calcolo di giacenze e vendite di tutto il catalogo, può richiedere un minuto.</div>
						</div>
						<template v-else-if="report">
							<InventoryOverview
								v-if="tabValue === 'overview'"
								:summary="report.summary"
								:suppliers="report.suppliers"
								@tab="vai"
								@open="apriFornitore"
								@print="stampa"
								@export="s => esporta({ view: 'reorder', supplier: s.supplierId || 'none' })"
							/>
							<template v-else>
								<div v-if="tabValue === 'reorder' && filters.supplier" class="d-flex align-center mb-2" style="gap: 8px">
									<v-btn small depressed color="primary" @click="stampa({ supplierId: filters.supplier === 'none' ? null : filters.supplier })">
										<v-icon small left>mdi-printer-outline</v-icon>
										Stampa la proposta di questo fornitore
									</v-btn>
									<v-btn small text color="primary" @click="azzera">Torna alle quantità proposte</v-btn>
								</div>
								<InventoryTable v-model="filters" :view="tabValue" :items="items" :total="total" :loading="loadingList" :saving="saving" :suppliers="suppliers" @override="correggi" />
							</template>
						</template>
					</v-col>
				</v-card>
			</v-layout>
		</v-container>
	</v-main>
</template>

<script>
import { mapActions, mapMutations } from 'vuex';
import InventoryOverview from '@/components/finance/inventory/InventoryOverview.vue';
import InventoryTable from '@/components/finance/inventory/InventoryTable.vue';
import { refreshMixin } from '@/components/finance/refreshMixin';
import { openWithReturn, returnInfo, goBackWithResult } from '@/components/core/pageReturn';

const TABS = [
	{ value: 'overview', label: 'Panoramica' },
	{ value: 'reorder', label: 'Riordino' },
	{ value: 'coverage', label: 'Copertura' },
	{ value: 'dead', label: 'Immobilizzato' },
];

const emptyFilters = query => ({
	supplier: query.supplier || '',
	abc: query.abc || '',
	dead: query.dead || '',
	search: query.q || '',
	options: { page: 1, itemsPerPage: 25, sortBy: [], sortDesc: [] },
});

export default {
	name: 'FinanceInventory',
	components: { InventoryOverview, InventoryTable },
	// "Aggiorna" ricalcola tutto il report scorte in coda
	mixins: [refreshMixin('inventory')],
	data() {
		return {
			ret: returnInfo(this.$route),
			TABS,
			tab: Math.max(
				0,
				TABS.findIndex(t => t.value === this.$route.query.tab),
			),
			report: null,
			items: [],
			total: 0,
			suppliers: [],
			filters: emptyFilters(this.$route.query),
			loading: false,
			loadingList: false,
			saving: '',
			range: {},
		};
	},
	computed: {
		tabValue() {
			return (TABS[this.tab] || TABS[0]).value;
		},
	},
	watch: {
		tab() {
			this.scriviUrl();
			this.caricaLista();
		},
		filters: {
			deep: true,
			handler() {
				this.scriviUrl();
				this.caricaLista();
			},
		},
		'$route.query.tab'(value) {
			const index = Math.max(
				0,
				TABS.findIndex(t => t.value === value),
			);
			if (index !== this.tab) this.tab = index;
		},
	},
	async mounted() {
		await this.carica();
		try {
			this.suppliers = (await this.fetchSettings()).suppliers || [];
		} catch (err) {
			this.errore(err);
		}
	},
	methods: {
		...mapMutations({ setLogout: 'profile/setLogout' }),
		back() {
			goBackWithResult(this.$router, this.ret, '', null);
		},
		...mapActions({
			fetchReport: 'finance/fetchInventoryReport',
			fetchList: 'finance/fetchInventoryList',
			setOverride: 'finance/setInventoryOverride',
			clearOverrides: 'finance/clearInventoryOverrides',
			fetchSettings: 'finance/fetchInventorySettings',
		}),
		scriviUrl() {
			const f = this.filters;
			const query = {};
			if (this.tab) query.tab = this.tabValue;
			if (f.supplier) query.supplier = f.supplier;
			if (f.abc) query.abc = f.abc;
			if (f.dead) query.dead = f.dead;
			if (f.search) query.q = f.search;
			if (this.$route.query.from) query.from = String(this.$route.query.from);
			if (JSON.stringify(query) !== JSON.stringify(this.$route.query)) this.$router.replace({ query }).catch(() => {});
		},
		async carica() {
			this.loading = true;
			try {
				this.report = await this.fetchReport();
				await this.caricaLista();
			} catch (err) {
				this.errore(err);
			} finally {
				this.loading = false;
			}
		},
		async caricaLista() {
			if (this.tabValue === 'overview' || !this.report) return;
			const f = this.filters;
			const o = f.options || {};
			this.loadingList = true;
			try {
				const res = await this.fetchList({
					view: this.tabValue,
					supplier: f.supplier || undefined,
					abc: f.abc || undefined,
					dead: this.tabValue === 'dead' ? f.dead || undefined : undefined,
					search: f.search || undefined,
					page: o.page || 1,
					perPage: o.itemsPerPage || 25,
					sortBy: o.sortBy && o.sortBy[0] ? o.sortBy[0] : undefined,
					sortDesc: o.sortBy && o.sortBy[0] ? (o.sortDesc && o.sortDesc[0] ? 'true' : 'false') : undefined,
				});
				this.items = res.items;
				this.total = res.total;
			} catch (err) {
				this.errore(err);
			} finally {
				this.loadingList = false;
			}
		},
		vai(tab) {
			this.tab = Math.max(
				0,
				TABS.findIndex(t => t.value === tab),
			);
		},
		apriFornitore(s) {
			this.filters = { ...this.filters, supplier: s.supplierId || 'none', options: { ...this.filters.options, page: 1 } };
			this.vai('reorder');
		},
		stampa(s) {
			openWithReturn(this, { path: '/finance/inventory/print', query: { supplier: s.supplierId || 'none' } }, { label: 'Torna al report scorte' });
		},
		esporta(filters) {
			this.exportAsync('inventoryreport', 'excel', { ...filters, abc: this.filters.abc || undefined });
		},
		// quantita' corretta a mano (null = torna alla proposta): resta salvata
		async correggi(item, value) {
			this.saving = item.key;
			try {
				const row = await this.setOverride({ key: item.key, qty: value === null || value === '' ? null : Math.max(0, Number(value)) });
				const i = this.items.findIndex(x => x.key === item.key);
				if (row && i >= 0) this.$set(this.items, i, row);
				this.report = await this.fetchReport();
			} catch (err) {
				this.errore(err);
			} finally {
				this.saving = '';
			}
		},
		async azzera() {
			try {
				const n = await this.clearOverrides(this.filters.supplier);
				this.notify('success', n ? `${n} quantità tornate alla proposta` : 'Nessuna quantità corretta a mano');
				await this.carica();
			} catch (err) {
				this.errore(err);
			}
		},
		notify(color, text) {
			this.$store.dispatch('settings/updateSnackbar', { color, text, snackbar: true, mode: 'multi-line', timeout: 5000 });
		},
		errore(err) {
			const res = err.response;
			if (res && res.status === 401) {
				this.setLogout();
				this.$router.push('/login');
				return;
			}
			this.notify('error', (res && res.data && res.data.message) || err.message);
		},
	},
};
</script>

<style scoped>
.iv-muted {
	font-size: 12px;
	color: #5f6b7a;
}
.iv-empty {
	text-align: center;
	padding: 60px 0;
}
</style>
